import { BaseIcon, BaseIconProps } from './BaseIcon';

export const CalendarGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="calendarGrad" {...props}>
    <rect width="18" height="18" x="3" y="4" rx="2" ry="2" stroke="url(#calendarGrad)" />
    <path d="M16 2v4M8 2v4M3 10h18" stroke="url(#calendarGrad)" />
  </BaseIcon>
);
